import { supabase } from './client';
import { getCurrentEmpresaId } from './auth-utils';

export interface VendaReport {
  id: string;
  order_code: string;
  customer_name: string;
  order_value: number;
  order_type: string;
  created_at: string;
  status: string;
  payment_method?: string;
}

/**
 * Lista todas as vendas (pedidos criados) em um período
 */
export async function listarVendasPorPeriodo(
  dataInicio: string,
  dataFim: string
): Promise<VendaReport[]> {
  try {
    const empresaId = await getCurrentEmpresaId();
    if (!empresaId) {
      return [];
    }

    // Buscar pedidos criados no período
    const { data, error } = await supabase
      .from('atelie_orders')
      .select('id, code, customer_name, value, type, created_at, status, payment_method')
      .eq('empresa_id', empresaId)
      .gte('created_at', `${dataInicio}T00:00:00`)
      .lte('created_at', `${dataFim}T23:59:59`)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Erro ao listar vendas:', error);
      return [];
    }

    return (data || []).map((order: any) => ({
      id: order.id,
      order_code: order.code || 'N/A',
      customer_name: order.customer_name || 'Cliente sem nome',
      order_value: Number(order.value || 0),
      order_type: order.type || 'Não especificado',
      created_at: order.created_at,
      status: order.status || 'Pendente',
      payment_method: order.payment_method
    }));
  } catch (error) {
    console.error('Erro ao listar vendas por período:', error);
    return [];
  }
}

/**
 * Gera estatísticas de vendas para um período
 */
export function gerarEstatisticasVendas(vendas: VendaReport[]) {
  const totalVendas = vendas.length;
  const valorTotal = vendas.reduce((sum, v) => sum + v.order_value, 0);
  const ticketMedio = totalVendas > 0 ? valorTotal / totalVendas : 0;

  return {
    totalVendas,
    valorTotal,
    ticketMedio,
    vendas
  };
}
